import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { HomeHeader } from '../home/HomeHeader'
import { useAuth } from '../../contexts/AuthContext'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs'
import { Button } from '../ui/button'
import { ChevronLeft } from 'lucide-react'
import { Card, CardContent } from '../ui/card'
import { AdminMemberships } from './AdminMemberships'
import { AdminPlanManagement } from './AdminPlanManagement'
import { TransactionsTable } from './TransactionsTable'

export function AdminMembershipManagement() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [activeTab, setActiveTab] = useState('memberships')

  // Initialize tab from URL search params
  useEffect(() => {
    const tab = searchParams.get('tab')
    if (tab && ['memberships', 'plans', 'transactions', 'revenue'].includes(tab)) {
      setActiveTab(tab)
    }
  }, [searchParams])

  const handleLogout = async () => {
    try {
      await logout()
      navigate('/')
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  return (
    <div className="admin-membership-management-page min-h-screen bg-background">
      <HomeHeader user={user} onLogout={handleLogout} />
      
      <div className="container mx-auto px-4 py-6">
        {/* Header */}
        <div className="header-section mb-6">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/admin')}
            className="mb-4"
          >
            <ChevronLeft className="mr-2 h-4 w-4" />
            Back to Dashboard
          </Button>
        </div>

        {/* Tabs */}
        <Tabs 
          value={activeTab} 
          onValueChange={(value) => {
            setActiveTab(value)
            // Update URL with tab parameter without navigation
            const newSearchParams = new URLSearchParams(searchParams)
            newSearchParams.set('tab', value)
            navigate(`/admin/memberships?${newSearchParams.toString()}`, { replace: true })
          }} 
          className="membership-management-tabs space-y-6"
        >
          <TabsList className="grid w-full max-w-3xl grid-cols-4">
            <TabsTrigger value="memberships">Memberships</TabsTrigger>
            <TabsTrigger value="plans">Plans</TabsTrigger>
            <TabsTrigger value="transactions">Transactions</TabsTrigger>
            <TabsTrigger value="revenue">Revenue</TabsTrigger>
          </TabsList>

          <TabsContent value="memberships" className="memberships-tab space-y-4">
            <AdminMemberships />
          </TabsContent>

          <TabsContent value="plans" className="plans-tab space-y-4">
            <AdminPlanManagement />
          </TabsContent>

          <TabsContent value="transactions" className="transactions-tab space-y-4">
            <Card>
              <CardContent className="pt-6">
                <TransactionsTable isActive={activeTab === 'transactions'} />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="revenue" className="revenue-tab space-y-4">
            <div className="text-center py-12 text-muted-foreground">
              <p className="mb-2">Revenue analytics coming soon</p>
              <p className="text-sm">Track subscription revenue, churn, and growth metrics</p>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  )
}

